import * as React from "react";

interface INxSpinnerProps {
	label?: string;
	isBusy?: boolean;
}
 
export class NxSpinner extends React.Component<INxSpinnerProps, {}> {
	 
	render() {
		const { isBusy } = this.props; 
		return <>
			{
				isBusy ?
					<span style={{ display: "grid", justifyContent:"center"}}>
						<div className="spinner-inner">
							<i>
								<svg className="spinner-animation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
									<path className="spinner-custom" d="M24,5A19,19,0,0,1,43,24h3A22,22,0,0,0,24,2Z" />
									<path d="M24,43A19,19,0,0,1,24,5V2A22,22,0,1,0,46,24H43A19,19,0,0,1,24,43Z" />
								</svg>
							</i>
						</div>
						<div className="spinner-label">Loading...</div>
					 </span> : null
			}
		</>;
	}
}